<template>
    <div class="card border-light rounded-3 shadow-lg">
        <div class="card-body">
            <h2 class="card-title h4 mb-4 text-primary text-center text-md-start">Mot de passe oublié</h2>

            <form @submit.prevent="recoverPassword">
                <div class="mb-3">
                    <label class="form-control-placeholder" for="username">Identifiant</label>
                    <input type="text" id="username" v-model="num" class="form-control" placeholder="Votre identifiant administrateur" required />
                </div>

                <div class="mb-3">
                    <label class="form-control-placeholder" for="email">E-mail ou numéro de téléphone</label>
                    <input type="text" id="email" v-model="email" class="form-control" placeholder="Votre adresse e-mail ou numéro de téléphone" required />
                </div>

                <div ref="captcha" class="d-flex justify-content-center"></div>

                <div
                    :class="'alert' + (alert ? ' alert-' + alert.class : '') + ' text-center p-1 mt-2 fs-n1' + (!alert ? ' invisible' : '')"
                    role="alert"
                    v-html="alert ? alert.message : '&nbsp;'"
                ></div>

                <div v-if="!alert || alert.class !== 'success'" class="mt-4 mb-2 text-center">
                    <button type="submit" class="btn btn-primary rounded-pill" :disabled="loading">Réinitialiser</button>
                </div>

                <div class="text-center">
                    <router-link to="/admin" class="card-link fs-n1">Retour</router-link>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { ref, watch, onBeforeUnmount } from 'vue'
import { getCaptcha } from '../../tools';

export default {
    name: 'RecoveryForm',
    setup() {
        const captcha = ref(null)
        const widget = ref(null)

        const captchaKey = process.env.VUE_APP_CAPTCHA_PUBLIC_KEY
        const captchaToken = ref(null)
        const loading = ref(false)

        watch(captcha, () => {
            // reset the widget instance when the container changes
            if (widget.value) {
                widget.value.destroy()
                widget.value = null
            }

            if (captcha.value) {
                widget.value = getCaptcha(captcha.value, captchaKey, captchaToken, loading)
            }
        })

        const resetCaptcha = () => {
            captchaToken.value = null
            if (widget.value) {
                widget.value.reset()
            }
            
            if (captcha.value) {
                widget.value = getCaptcha(captcha.value, captchaKey, captchaToken, loading)
            }
        }

        onBeforeUnmount(() => {
            if (widget.value) {
                widget.value.destroy()
            }
        })

        return {
            captcha,
            captchaKey,
            captchaToken,
            loading,
            resetCaptcha,
        }
    },
    data: () => ({
        num: '',
        email: '',
        alert: null,
    }),
    computed: {
        ...mapGetters(['isAuth']),
    },
    methods: {
        ...mapActions(['resetPasswordAdmin']),
        async recoverPassword() {
            this.loading = true
            this.alert = await this.resetPasswordAdmin({
                login: this.num,
                email: this.email,
                captcha: this.captchaToken,
            })
            this.loading = false
            if (this.alert.class !== 'success') {
                this.resetCaptcha()
                // this.num = ''
                // this.email = ''
            }
        },
    },
}
</script>
